const auth = {
  LOGIN: '/login',
  FORGOT: '/forgot',
  RESET: '/reset-password',
}
export default auth
